<template>
    <div class="SubForm">
        <div on.submit.prevent class="row">
            <div class="column">
                <label>Product</label>
                <input type="text" v-model="product.name">
                <label>Price ($)</label>
                <input type="number" step="0.01" v-model="product.price">
                <label>GST</label>
                <input type="checkbox" v-model="product.gst">
            </div>
            <div class="column">
                <label>Description</label>
                <textarea v-model="product.description"></textarea>
                <label>Notes</label>
                <textarea v-model="product.notes"></textarea>
            </div>
        </div>
        <button @click="saveProduct">Save</button>
    </div>
</template>

<script>
import { CallApi } from '../Utilities'
export default {
    name: "StockCreate",
    data: function() {
        return {
            product:{
                name:'',
                price:0.00,
                gst:false,
                description:'',
                notes:''
            }
        }
    },
    methods: {
        saveProduct: async function() {
            const apiResponse = await CallApi('POST', '/inventory', this.product)
            this.$router.push(`/inventory/${apiResponse.product.id}`)
        }
    }
}
</script>